import styled, { css } from "styled-components";
import { space } from "styled-system";
import { SaddleProps } from "./types";
import { Paragraph } from "../Typography";

const hexToRgba = (hexCode = "#fff", opacity = 1) => {
  let hex = hexCode.replace("#", "");

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
};

export const StyledSaddle = styled.div<
  Pick<
    SaddleProps,
    | "all"
    | "saddleColor"
    | "fullHeight"
    | "isScratched"
    | "size"
    | "raceFinished"
    | "enableMyBetsBehavior"
    | "isWinner"
    | "showAlternateIcon"
  >
>`
  align-items: center;
  background-color: ${({
    saddleColor,
    isScratched,
    isWinner,
    raceFinished,
    enableMyBetsBehavior
  }) =>
    isScratched || (enableMyBetsBehavior && raceFinished && !isWinner)
      ? `${hexToRgba(saddleColor, 0.4)}`
      : saddleColor};
  border-radius: 2px;
  display: flex;
  justify-content: center;
  position: relative;
  ${({ isScratched, enableMyBetsBehavior }) =>
    isScratched &&
    enableMyBetsBehavior &&
    css`
      box-shadow: inset 0 0 0 2px var(--fd-colors-core-grey-d-2);
    `}
  ${({ showAlternateIcon }) =>
    showAlternateIcon &&
    css`
      & > svg {
        position: absolute;
        top: -8px;
        right: -8px;
        z-index: 2;
      }
    `}
  ${({ size, fullHeight, all }) => {
    if (fullHeight && size !== "s") {
      return css`
        flex-grow: 1;
        height: 100%;
        width: 32px;
      `;
    }
    if (all === true && size === "s") {
      return css`
        width: 44px;
        height: 20px;
      `;
    }

    return css`
      height: ${size === "s" ? "20px" : "44px"};
      width: ${size === "s" ? "20px" : "32px"};
    `;
  }}
  ${space};

  ${({ isWinner }) =>
    isWinner &&
    css`
      &::after {
        content: "";
        position: absolute;
        top: 12px;
        left: 12px;
        width: 12px;
        height: 12px;
        z-index: 2;
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.438 6.00219C11.438 9.00537 9.00342 11.4399 6.00024 11.4399C2.99706 11.4399 0.5625 9.00537 0.5625 6.00219C0.5625 2.99901 2.99706 0.564453 6.00024 0.564453C9.00342 0.564453 11.438 2.99901 11.438 6.00219Z' fill='%23128000'/%3E%3Cpath d='M3.37527 6.0001L5.25027 7.8751L9.00027 4.1251M11.438 6.00219C11.438 9.00537 9.00342 11.4399 6.00024 11.4399C2.99706 11.4399 0.5625 9.00537 0.5625 6.00219C0.5625 2.99901 2.99706 0.564453 6.00024 0.564453C9.00342 0.564453 11.438 2.99901 11.438 6.00219Z' stroke='white'/%3E%3C/svg%3E ");
      }
    `};
`;

export const DiagonalLine = styled.div`
  position: absolute;
  width: 24px;
  height: 2px;
  background-color: var(--fd-colors-core-grey-d-2);
  top: calc(50% - 1px);
  left: -2px;
  transform: rotate(135deg);
  z-index: 1;
`;

export const StyledParagraph = styled(Paragraph)<
  Pick<
    SaddleProps,
    | "size"
    | "isScratched"
    | "isWinner"
    | "raceFinished"
    | "enableMyBetsBehavior"
  >
>`
  font-family: ${({ size }) =>
    size === "s"
      ? `${'"Roboto-Regular", sans-serif'}`
      : `${'"Roboto-Bold", sans-serif'}`};
  font-size: ${({ size }) => (size === "s" ? "12px" : "18px")};
  text-align: center;
  line-height: ${({ size }) => (size === "s" ? "15px" : "22px")};
  opacity: ${({ isScratched, isWinner, raceFinished, enableMyBetsBehavior }) =>
    isScratched || (enableMyBetsBehavior && raceFinished && !isWinner)
      ? 0.4
      : 1};
`;
